import { SsAccord } from 'src/js/dom/accord.js';

export default function () {
  const elms = document.querySelectorAll( '.ss-accord' );
  Array.prototype.forEach.call( elms, elm => {
    new SsAccord( elm ).onClick();
  });
}
